import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "inline-items" }
const _hoisted_3 = {
  for: "invoice",
  class: "mt-1"
}
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-md-8" }
const _hoisted_7 = { class: "inline-items" }
const _hoisted_8 = {
  key: 0,
  class: "mr-md-5"
}
const _hoisted_9 = { class: "green-text" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "green-text" }
const _hoisted_12 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_13 = { class: "text-md-right" }
const _hoisted_14 = {
  key: 0,
  class: "badge badge-dim badge-warning ml-1"
}
const _hoisted_15 = {
  key: 1,
  class: "badge badge-dim badge-warning ml-1 text-orange"
}
const _hoisted_16 = {
  key: 2,
  class: "badge badge-dim badge-warning ml-1 text-green"
}
const _hoisted_17 = {
  key: 3,
  class: "badge badge-dim badge-warning ml-1 text-red"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { key: 4 }
const _hoisted_26 = { key: 5 }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Billed To :")
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { key: 3 }
const _hoisted_33 = { key: 4 }
const _hoisted_34 = { key: 5 }
const _hoisted_35 = { class: "mt-4" }
const _hoisted_36 = { class: "table-responsive my-3 font-12" }
const _hoisted_37 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_38 = { class: "table-primary nowrap-text" }
const _hoisted_39 = { scope: "col" }
const _hoisted_40 = { scope: "col" }
const _hoisted_41 = { scope: "col" }
const _hoisted_42 = { scope: "col" }
const _hoisted_43 = {
  key: 0,
  scope: "col"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "fa fa-minus" }, null, -1)
const _hoisted_47 = { key: 1 }
const _hoisted_48 = {
  key: 0,
  class: "row"
}
const _hoisted_49 = { class: "col-md-4 offset-md-8" }
const _hoisted_50 = { class: "shadowed-card" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-6" }
const _hoisted_53 = { class: "col-6 text-right" }
const _hoisted_54 = { class: "mb-1" }
const _hoisted_55 = { class: "col-6" }
const _hoisted_56 = { class: "col-6 text-right" }
const _hoisted_57 = { class: "mb-1" }
const _hoisted_58 = { class: "col-6" }
const _hoisted_59 = { class: "col-6 text-right" }
const _hoisted_60 = { class: "mb-1" }
const _hoisted_61 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-6" }
const _hoisted_64 = { class: "col-6 text-right" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = {
  key: 1,
  class: "row"
}
const _hoisted_68 = { class: "col-md-4 offset-md-8" }
const _hoisted_69 = { class: "shadowed-card" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "col-6" }
const _hoisted_72 = { class: "col-6 text-right" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { class: "col-6" }
const _hoisted_76 = { class: "col-6 text-right" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { class: "col-6" }
const _hoisted_80 = { class: "col-6 text-right" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col-6" }
const _hoisted_86 = { class: "col-6 text-right" }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = { class: "inline-items" }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = { key: 2 }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_big = _resolveComponent("big")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    (!_ctx.isEmpty(_ctx.state.data.invoiceDetails))
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("ul", null, [
                _createVNode("li", null, [
                  _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('choose_an_invoice')) + ":", 1)
                ]),
                _createVNode("li", null, [
                  _withDirectives(_createVNode("select", {
                    name: "invoice",
                    id: "invoice",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.selectedInvoice = $event)),
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getInvoiceByPhaseOrTask(_ctx.state.data.selectedInvoice)))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invoices, (invoice, invoiceIndex) => {
                      return (_openBlock(), _createBlock("option", {
                        value: invoice,
                        key: invoiceIndex
                      }, " #" + _toDisplayString(invoice.invoice_no) + "(" + _toDisplayString(invoice.invoice_date) + ") ", 9, ["value"]))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.state.data.selectedInvoice]
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("ul", null, [
                    (
                    _ctx.state.data.invoiceDetails &&
                    _ctx.state.data.invoiceDetails.invoice_no
                  )
                      ? (_openBlock(), _createBlock("li", _hoisted_8, [
                          _createVNode("p", null, [
                            _createVNode(_component_big, null, {
                              default: _withCtx(() => [
                                _createVNode("strong", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('invoice_no')) + ": ", 1),
                                  _createVNode("span", _hoisted_9, "#" + _toDisplayString(_ctx.state.data.invoiceDetails.invoice_no), 1)
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("li", null, [
                      (
                      _ctx.state.data.invoiceDetails &&
                      _ctx.state.data.invoiceDetails.invoice_date
                    )
                        ? (_openBlock(), _createBlock("p", _hoisted_10, [
                            _createVNode(_component_big, null, {
                              default: _withCtx(() => [
                                _createVNode("strong", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('invoice_date')) + ": ", 1),
                                  _createVNode("span", _hoisted_11, _toDisplayString(_ctx.state.data.invoiceDetails.invoice_date), 1)
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (_ctx.state.data.invoiceDetails && _ctx.state.data.invoiceDetails.status)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('status')) + " :", 1),
                        (_ctx.state.data.invoiceDetails.status === 1)
                          ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('pending')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.state.data.invoiceDetails.status === 2)
                          ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.$t('partial_paid')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.state.data.invoiceDetails.status === 3)
                          ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('paid')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.state.data.invoiceDetails.status === 4)
                          ? (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('halt')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_18,
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.error.errorList.getInvoiceByPhaseOrTask,
              hasError: _ctx.state.ui.error.hasError
            }, null, 8, ["errors", "hasError"]),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode("p", null, [
                  _createVNode("strong", null, [
                    _createVNode(_component_big, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('billed_from')) + " :", 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (
                _ctx.state.data.invoiceDetails.billed_from_user &&
                _ctx.state.data.invoiceDetails.billed_from_user.email
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_21, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.email), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_from_user &&
                _ctx.state.data.invoiceDetails.billed_from_user.full_name
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_22, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.full_name), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_from_user &&
                _ctx.state.data.invoiceDetails.billed_from_user.address_line1
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_23, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.address_line1), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_from_user &&
                _ctx.state.data.invoiceDetails.billed_from_user.address_line2
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_24, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.address_line2), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_from_user &&
                _ctx.state.data.invoiceDetails.billed_from_user.city
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_25, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.city), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_from_user &&
                _ctx.state.data.invoiceDetails.billed_from_user.country
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_26, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.country), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_27, [
                _createVNode("p", null, [
                  _createVNode("strong", null, [
                    _createVNode(_component_big, null, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.email
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_29, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.email), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.full_name
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_30, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.full_name), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.address_line1
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_31, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.address_line1), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.address_line2
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_32, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.address_line2), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.city
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_33, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.city), 1))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.country
              )
                  ? (_openBlock(), _createBlock("p", _hoisted_34, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.country), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("p", _hoisted_35, [
              _createVNode("strong", null, [
                _createVNode(_component_big, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('title')) + " :", 1)
                  ]),
                  _: 1
                })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.state.data.invoiceDetails.title), 1)
            ]),
            _createVNode("div", _hoisted_36, [
              _createVNode("table", _hoisted_37, [
                _createVNode("thead", _hoisted_38, [
                  _createVNode("tr", null, [
                    _createVNode("th", _hoisted_39, _toDisplayString(_ctx.$t('description')), 1),
                    _createVNode("th", _hoisted_40, _toDisplayString(_ctx.$t('cost_per_hour')), 1),
                    _createVNode("th", _hoisted_41, _toDisplayString(_ctx.$t('quantity_per_hour')), 1),
                    _createVNode("th", _hoisted_42, _toDisplayString(_ctx.$t('amount')), 1),
                    (_ctx.isAuthEdit)
                      ? (_openBlock(), _createBlock("th", _hoisted_43, _toDisplayString(_ctx.$t('action')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (
                _ctx.isAuthEdit &&
                _ctx.state.data.invoiceDetails.invoice_items &&
                _ctx.state.data.invoiceDetails.invoice_items.length
              )
                  ? (_openBlock(), _createBlock("tbody", _hoisted_44, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invoiceCalculate, (invoiceDetail, invoiceDetailIndex) => {
                        return (_openBlock(), _createBlock("tr", { key: invoiceDetailIndex }, [
                          _createVNode("td", null, [
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": ($event: any) => (invoiceDetail.title = $event)
                            }, null, 8, ["onUpdate:modelValue"]), [
                              [_vModelText, invoiceDetail.title]
                            ])
                          ]),
                          _createVNode("td", null, [
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": ($event: any) => (invoiceDetail.cost = $event)
                            }, null, 8, ["onUpdate:modelValue"]), [
                              [_vModelText, invoiceDetail.cost]
                            ])
                          ]),
                          _createVNode("td", null, [
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": ($event: any) => (invoiceDetail.quantity = $event)
                            }, null, 8, ["onUpdate:modelValue"]), [
                              [_vModelText, invoiceDetail.quantity]
                            ])
                          ]),
                          _createVNode("td", null, [
                            _withDirectives(_createVNode("input", {
                              disabled: "",
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": ($event: any) => (invoiceDetail.amount = $event)
                            }, null, 8, ["onUpdate:modelValue"]), [
                              [_vModelText, invoiceDetail.amount]
                            ])
                          ]),
                          _createVNode("td", null, [
                            (invoiceDetailIndex + 1 === _ctx.invoiceCalculate.length)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: "javascript:void(0)",
                                  class: "btn enable-btn mr-1",
                                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addItemInInvoice && _ctx.addItemInInvoice(...args)))
                                }, [
                                  _hoisted_45
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              class: "btn delete-btn mr-1",
                              onClick: ($event: any) => (_ctx.removeSelectedItemInInvoice(invoiceDetail))
                            }, [
                              _hoisted_46
                            ], 8, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock("tbody", _hoisted_47, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                  .invoiceDetails.invoice_items, (invoiceDetail, invoiceDetailIndex) => {
                        return (_openBlock(), _createBlock("tr", { key: invoiceDetailIndex }, [
                          _createVNode("td", null, _toDisplayString(invoiceDetail.title), 1),
                          _createVNode("td", null, "$ " + _toDisplayString(invoiceDetail.cost), 1),
                          _createVNode("td", null, _toDisplayString(invoiceDetail.quantity), 1),
                          _createVNode("td", null, "$ " + _toDisplayString(invoiceDetail.amount), 1)
                        ]))
                      }), 128))
                    ]))
              ])
            ]),
            (_ctx.isAuthEdit)
              ? (_openBlock(), _createBlock("div", _hoisted_48, [
                  _createVNode("div", _hoisted_49, [
                    _createVNode("div", _hoisted_50, [
                      _createVNode("div", _hoisted_51, [
                        _createVNode("div", _hoisted_52, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('sub_total')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_53, [
                          _createVNode("div", _hoisted_54, [
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.invoice.subTotal = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.data.invoice.subTotal]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_55, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('tax')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_56, [
                          _createVNode("div", _hoisted_57, [
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.invoice.tax = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.data.invoice.tax]
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_58, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('discount')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_59, [
                          _createVNode("div", _hoisted_60, [
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.invoice.discount = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.data.invoice.discount]
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_61,
                      _createVNode("div", _hoisted_62, [
                        _createVNode("div", _hoisted_63, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, [
                              _createVNode(_component_big, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('total')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_64, [
                          (_ctx.state.data.invoice.total)
                            ? (_openBlock(), _createBlock("p", _hoisted_65, " $" + _toDisplayString(_ctx.state.data.invoice.total), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_66, "$0"))
                        ])
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_67, [
                  _createVNode("div", _hoisted_68, [
                    _createVNode("div", _hoisted_69, [
                      _createVNode("div", _hoisted_70, [
                        _createVNode("div", _hoisted_71, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('sub_total')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_72, [
                          (_ctx.state.data.invoiceDetails.sub_total)
                            ? (_openBlock(), _createBlock("p", _hoisted_73, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.sub_total), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_74, "$0"))
                        ]),
                        _createVNode("div", _hoisted_75, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('tax')) + " (" + _toDisplayString(_ctx.state.data.invoiceDetails.tax) + "%)", 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_76, [
                          (_ctx.state.data.invoiceDetails.tax_amount)
                            ? (_openBlock(), _createBlock("p", _hoisted_77, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.tax_amount), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_78, "$0"))
                        ]),
                        _createVNode("div", _hoisted_79, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('discount')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_80, [
                          (_ctx.state.data.invoiceDetails.discount)
                            ? (_openBlock(), _createBlock("p", _hoisted_81, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.discount), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_82, "$0"))
                        ])
                      ]),
                      _hoisted_83,
                      _createVNode("div", _hoisted_84, [
                        _createVNode("div", _hoisted_85, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, [
                              _createVNode(_component_big, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('total')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_86, [
                          (
                      _ctx.state.data.invoiceDetails && _ctx.state.data.invoiceDetails.total
                    )
                            ? (_openBlock(), _createBlock("p", _hoisted_87, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.total), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_88, "$0"))
                        ])
                      ])
                    ])
                  ])
                ])),
            _createVNode("div", _hoisted_89, [
              _createVNode("ul", null, [
                (_ctx.state.data.isPayActive)
                  ? (_openBlock(), _createBlock("li", _hoisted_90, [
                      _createVNode("a", {
                        id: "createNewProject",
                        href: "javascript:void(0)",
                        class: "btn default-btn",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.choosePaymentMode && _ctx.choosePaymentMode(...args)))
                      }, _toDisplayString(_ctx.state.ui.isPostLoading.confirmPayment ? _ctx.$t('loading1') : _ctx.$t('pay')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isAuthEdit)
                  ? (_openBlock(), _createBlock("li", _hoisted_91, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn default-btn outline",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.stripeAccountCheck && _ctx.stripeAccountCheck(...args)))
                      }, _toDisplayString(_ctx.state.ui.isPostLoading.generateInvoice
                ? "Loading..."
                : "Generate Invoice"), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.invoiceDetails && _ctx.state.data.invoiceDetails.pdf_url
              )
                  ? (_openBlock(), _createBlock("li", _hoisted_92, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn default-btn outline",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
                      }, _toDisplayString(_ctx.$t('download_pdf')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 64))
      : (_openBlock(), _createBlock(_component_EmptyData, {
          key: 1,
          class: "mt-10",
          title: "invoice has been requested"
        })),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 2,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage,
          isButton: true
        }, {
          default: _withCtx(() => [
            (_ctx.state.data.stripeUrl)
              ? (_openBlock(), _createBlock("div", _hoisted_93, [
                  _createVNode("p", null, _toDisplayString(_ctx.$t('you_dont_have_stripe_account')), 1),
                  (!_ctx.state.ui.isPostLoading.stripeAccount)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "btn-link mt-2",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.redirectToStripeAccount && _ctx.redirectToStripeAccount(...args)))
                      }, _toDisplayString(_ctx.$t('click_to_setup_account')), 1))
                    : (_openBlock(), _createBlock("p", _hoisted_94, _toDisplayString(_ctx.$t('loading1')), 1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.stripeSuccess)
              ? (_openBlock(), _createBlock("div", _hoisted_95, [
                  (!_ctx.state.ui.isPostLoading.generateInvoice)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.generateInvoice && _ctx.generateInvoice(...args)))
                      }, _toDisplayString(_ctx.$t('click_to_generate_invoice')), 1))
                    : (_openBlock(), _createBlock("p", _hoisted_96, _toDisplayString(_ctx.$t('loading1')), 1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ]))
}